import { styled } from '@slal/ui';
import { UnitsSwitch } from '@slal/ui/react-hook-form/fields';

export const StyledSwitch = styled(UnitsSwitch)`
    button {
        &[aria-current='true'] {
            background-color: ${({ theme }) => theme.colors.neutral__light__00};
            color: ${({ theme }) => theme.colors.aqua__70};
        }

        &:not([aria-current='true']) {
            background-color: ${({ theme }) => theme.colors.aqua__70};
            color: ${({ theme }) => theme.colors.neutral__light__00};
        }

        min-width: 26px;
        font-size: 14px;
        width: 26px;
        min-height: 26px;
        height: 26px;
        padding: 0;
        border-color: ${({ theme }) => theme.colors.aqua__70};

        &:not(:first-child) {
            margin-left: -2px;
        }

        &:focus {
            position: relative;
            z-index: 1;
        }
    }
`;
